import { render } from "./Promo-ads.vue?vue&type=template&id=42109902&scoped=true"
import script from "./Promo-ads.vue?vue&type=script&lang=js"
export * from "./Promo-ads.vue?vue&type=script&lang=js"

import "./Promo-ads.vue?vue&type=style&index=0&id=42109902&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42109902"]])

export default __exports__